import { openRiesterDetail } from "./detail"
import { seriesBuschutz, seriesLiqui, seriesSteuer } from "./series"
import { buildConfig } from "./config"
import { updateDataGrouping, updateXAxisMinMax, updateBewertungLinie } from "./helpers"
import { ChartConstants } from "../shared/constants"
import { riesterDefaults } from "./defaults"

export function createRiesterChart() {
	const obj = {
		data: {
			// Liqui
			bruttowerte: [],
			bruttowerte_beitraege: [],
			bruttowerte_zulagen: [],
			deckungsstoecke: [],
			vorsorgebeitraege: [],
			zulagen: [],
			leistungen: [],
			// Steuer
			zves: [],
			sozialpflichtiges_einkommens: [],
			// BU-Schutz
			bu_leistungen: [],
			burente_beitraege: [],
			beitragsbefreiung_beitraege: [],
			// Sonstiges
			bewertungsdatum: 0,
			bewertungswert: 0,
			leistungsdatum: 0,
			startdatum: 0,
			enddatum: 0,
			anzeigeformat: "jahr",
			chartType: "liqui",
			status: "konsolidiert",
			charteinstellungen: { hidden_series: [], bruttowert_ansicht: "konsolidiert" },
			detailUrl: null,
			detailFrameId: null,
		},

		onZoomIn: () => {},
		onZoomReset: () => {},
		onLegendToggle: () => {},

		setZoomCallbacks({ onZoomIn, onZoomReset }) {
			if (typeof onZoomIn === "function") this.onZoomIn = onZoomIn
			if (typeof onZoomReset === "function") this.onZoomReset = onZoomReset
		},

		setChartSettingsCallbacks({ onLegendToggle }) {
			if (typeof onLegendToggle === "function") this.onLegendToggle = onLegendToggle
		},

		showLoading() {
			if (this.chart) this.chart.showLoading()
		},

		hideLoading() {
			if (this.chart) this.chart.hideLoading()
		},

		init() {
			const options = Highcharts.merge(riesterDefaults(), buildConfig(this))
			this.chart = new Highcharts.stockChart("chart_riester", options)
			this.updateDetailInteraktion()

			updateDataGrouping(this.chart, this.data.startdatum, this.data.enddatum)
			updateBewertungLinie(this)
		},

		update() {
			if (!this.chart) return

			this.chart.showLoading()

			const seriesArrays = [seriesLiqui(this.data), seriesSteuer(this.data), seriesBuschutz(this.data)]
			const alleSeries = [].concat(...seriesArrays)

			alleSeries.forEach((serie) => {
				const s = this.chart.get(serie.id)
				if (!s) return

				s.setData(serie.data, false)
			})

			updateXAxisMinMax(this)
			updateBewertungLinie(this)

			this.chart.redraw({ duration: ChartConstants.animationDuration })
			this.chart.hideLoading()
		},

		updateSeriesData(seriesData, chartType) {
			this.data.chartType = chartType
			this.chart.update({ series: seriesData }, false, true)
			this.updateDetailInteraktion()

			updateXAxisMinMax(this)
			updateBewertungLinie(this)
			this.chart.redraw({ duration: ChartConstants.animationDuration })
		},

		openDetailansicht(zeitpunkt) {
			if (this.data.chartType === "buschutz") return
			if (!this.data.detailUrl || !this.data.detailFrameId) return

			openRiesterDetail({
				url: this.data.detailUrl,
				zeitpunktUtcMs: zeitpunkt,
				anzeigeformat: this.data.anzeigeformat,
				chartType: this.data.chartType || "liqui",
				frameId: this.data.detailFrameId,
			})
		},

		isSeriesHidden(seriesId) {
			const hs = this.data?.charteinstellungen?.hidden_series
			if (!Array.isArray(hs)) return false
			return hs.map(String).includes(String(seriesId))
		},

		visibleBySettings(seriesId, defaultVisible) {
			return this.isSeriesHidden(seriesId) ? false : defaultVisible
		},

		toggleHiddenSeriesLocal(seriesId, willBeVisible) {
			const id = String(seriesId)
			const settings = (this.data.charteinstellungen ||= {})
			const hs = Array.isArray(settings.hidden_series) ? settings.hidden_series.map(String) : []

			settings.hidden_series = hs

			if (willBeVisible) {
				settings.hidden_series = settings.hidden_series.filter((x) => x !== id)
			} else if (!settings.hidden_series.includes(id)) {
				settings.hidden_series.push(id)
			}
		},

		updateDetailInteraktion() {
			if (!this.chart) return

			const detailAktiv = this.data.chartType !== "buschutz"
			this.chart.update(
				{
					plotOptions: {
						series: {
							cursor: detailAktiv ? "pointer" : "default",
						},
					},
				},
				false,
				false
			)
		},
	}

	return obj
}
